import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {Job} from "../../Authenticated/Employee/Types/Job";

interface IApplication{
    id: string,
    name: string,
    picture: string,
    edu: string,
    age: string,
    fromSadat: string,
}

export interface IApplicantsState{
  page?: number;
  data?: [] | [IApplication];
  total?: number;
  lastPage?: number;
  jobId?: string | null;
}

const initialState: IApplicantsState = {
  page: 1,
  data: [],
  total: 0,
  lastPage: 0,
  jobId: null
}
export interface IJobsState{

    data?: [] | [Job];

}

export const applicantsSlice = createSlice({
  name: 'applicant',
  initialState,
  reducers: {
    setApplicants: (state, action: PayloadAction<IApplicantsState>) => {
          state.page = action.payload.page
          state.total = action.payload.total
          state.data = action.payload.data
          state.lastPage = action.payload.lastPage
          state.jobId = action.payload.jobId
    },
  },
})

// Action creators are generated for each case reducer function
export const { setApplicants } = applicantsSlice.actions

export default applicantsSlice.reducer